const namespace = "mrstaffingApp";

import AppConfig from "@/_config/application-config"
import childRoutes from "./routes"
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  // "namespace" : {
  name: "Maintenance & Reliability Staffing",
  namespace,
  description: null,
  version: "0.1.0",
  icon: "mdi-gauge",
  parentRoute: "/mrstaffing",
  defaultRoute: "Home",
  accentColor: "#000080",
  childRoutes,
  component : () => import(/* webpackChunkName: "mrstaffing-parent" */ "@/apps/mrstaffing/Application.vue"),
  navigation : [],
  settings: {
    navigation: [{
      text: "Home",
      link: `/mrstaffing/Home`,
      icon: "mdi-home",
    },
    {
      icon: "mdi-cog",
      text: "Admin",
      link: "",
      items: [ 
        {
          text: "Lock & Unlock data",
          link: `/mrstaffing/Admin/LockData`,
          icon: "mdi-lock",
        },        
        {
          icon: "mdi-all-inclusive",
          text: "Benchmark File Upload",
          link: `/mrstaffing/Admin/BenchmarkFileUpload`,        
        },
         
      ],
    },
    {
      icon: "mdi-cog",
      text: "Data Entry",
      link: "",
      items: [ 
        {
          text: "Maintenance & Reliablity",
          link: `/mrstaffing/DataEntry/MaintenanceReliability`,
          icon: "mdi-account-multiple",
        },        
        {
          icon: "mdi-all-inclusive",
          text: "Process Technical & Operations",
          link: "/mrstaffing/DataEntry/TechnologyOperation",        
        },
      ],
    },
    {
      icon: "mdi-cog",
      text: "Master Data",
      link: "",
      items: [ 
        {
          text: "ARV",
          link: `/mrstaffing/MasterData/Arv`,
          icon: "mdi-chart-sankey",
        },   
        {
          text: "Users",
          link: `/mrstaffing/MasterData/MrUser`,
          icon: "mdi-account",
        },        
        {
          icon: "mdi-all-inclusive",
          text: "General",
          link: "/mrstaffing/MasterData/General",        
        },
        {
          icon: "mdi-group",
          text: "Groups",
          link: "/mrstaffing/MasterData/MrGroup",        
        },
        {
          text: "Personnel Description",
          link: `/mrstaffing/MasterData/PersonnelDescription`,
          icon: "mdi-shape",
        },   
        {
          icon: "mdi-check-decagram",
          text: "Plant Area",
          link: "/mrstaffing/MasterData/PlantArea",        
        },
        {
          text: "Plant Area User",
          link: `/mrstaffing/MasterData/PlantAreaUser`,
          icon: "mdi-account-multiple",
        },   
      ],
    },
    {
      icon: "mdi-home-analytics",
      text: "Report",
      link: "",
      items: 
      [ 
        {
          icon: "mdi-file-chart-outline",
          text: "PowerBI",
          link: `/mrstaffing/Report/PowerBI`,        
        },
      ],
    },
  ],
    userRoles:{
      GlobalAdmin: 1,
      SiteAdmin: 2,
      SiteUser: 3,
      GlobalViewer: 4,
    },
    global_admin_link: "https://myaccess.microsoft.com/@LyondellBasell.onmicrosoft.com#/access-packages/eef007d8-34ad-42c3-bda1-13f5b7f376f0",
    site_admin_link: "https://myaccess.microsoft.com/@LyondellBasell.onmicrosoft.com#/access-packages/bc056de5-45d9-4347-9b0c-526c95dd07a1",
    site_user_link: "https://myaccess.microsoft.com/@LyondellBasell.onmicrosoft.com#/access-packages/ff45a97b-a984-425c-b55e-e04f432a0824",
    global_viewer_link: "https://myaccess.microsoft.com/@LyondellBasell.onmicrosoft.com#/access-packages/860c7229-f3c4-46c1-b344-12a844f2ac6d",
    FileType: {
      ARV: "mrs.ARV",
    },

    environment : "DEV",

    scope: "api://992b6e5f-fe33-4396-b903-ff28acdcf7e9/Read.All",
    clientId: "992b6e5f-fe33-4396-b903-ff28acdcf7e9",
    // scope: "api://a75bb62e-c676-4bd6-aa7b-da69c2ea109b/Read.All",
    // clientId: "a75bb62e-c676-4bd6-aa7b-da69c2ea109b",
    // scope: "api://0a00d2f5-2545-4cc9-9691-681cff842c47/Read.All",
    // clientId: "0a00d2f5-2545-4cc9-9691-681cff842c47",

    apiUrl: "https://localhost:44357/api",
    odataUrl: "https://localhost:44357/odata",
    // apiUrl: "https://localhost:8089/API/api",
    // odataUrl: "https://localhost:8089/API/odata",
    //apiUrl: "https://as-medappreq-api-dev.azurewebsites.net/api",
    authorizeUrl:  
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
    redirect_uri: window.location.origin,
    logoutUrl:
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=https://localhost:8080/",
    tokenUrl:
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",

    env_color_dev: { "r": 96, "g": 125, "b": 139, "a": 1 }, 
    env_color_stg: { "r": 38, "g": 166, "b": 154, "a": 1 },
    isAzureDeployed: true,
    //env_color:'"primary"', //PROD    
  },

  store: {
    //The store is made up of settings and attributes that should be accessible across components.
    //One common scenario would be user settings or profile preferences.  Some examples:
    //Date and Time Formats
    //Preferred configuration of a table view
    //Preferred theme color.
    pageTitle: {
      default: "Maintenance and Reliability Staffing Study",
      storageMode: localStorage,
    },
    userDetails: {
      default: {},
      storageMode: sessionStorage,
    },
    currentUserRoleId: {
      default: {},
      storageMode: sessionStorage,
    },
  },

}

export default AppConfig.merge(appConfig);


